import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment } from '@angular/router';
import { AuthService } from '@app/services/auth/auth.service';

@Injectable({ providedIn: 'root' })
export class IsClientGuard implements CanActivate, CanLoad {
  constructor(private authService: AuthService, private router: Router) {}

  async canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.check(state.url);
  }

  async canLoad(_route: Route, segments: UrlSegment[]) {
    // getCurrentNavigation gives the full target URL including child segments.
    // Fall back to reconstructing from segments if there is no active navigation.
    const nav = this.router.getCurrentNavigation();
    const url = nav ? nav.extractedUrl.toString() : '/' + segments.map(s => s.path).join('/');
    return this.check(url);
  }

  private async check(intendedUrl: string) {
    await this.authService.initializeAuth();
    if (this.authService.auth.isClientUser === true) {
      return true;
    }
    sessionStorage.setItem('clientReturnUrl', intendedUrl);
    this.router.navigateByUrl('/auth/login');
    return false;
  }
}
